<template>
  <div class="container">
    <div class="top">
      <div class="wapper w12 flex_a">
        <ul>
          <li @click="toManagerHome">平台首页</li>
          <li @click="toResources">资源中心</li>
          <li @click="toknowledge">知识中心</li>
          <li class="checked">资讯及书展</li>
          <li @click="toSphome">机构采选</li>
          <li @click="toPay">支付服务</li>
        </ul>
        <!-- <div><span>个人中心</span>|<span>注销</span></div> -->
        <div class="login-wrapper">
          <div v-if="isLogin" class="login">
            <span @click="toCenter">个人中心</span>
            <span class="line">|</span>
            <span @click="confirmLogout">退出</span>
          </div>
          <div v-else class="login">
            <span @click="doLogin">登录</span>
            <span class="line">|</span>
            <span @click="doSignUp">注册</span>
          </div>
          <login-menu
            :showLogin="showLogin"
            :tab="loginTab"
            @close-dialog="closeDialog"
          />
        </div>
      </div>
    </div>
    <div class="w12 logosearch flex_a">
      <img
        src="../../assets/images/zxjsz-logo.png"
        alt=""
        @click="toIndex"
        style="cursor: pointer;"
      />
      <div class="search_main">
        <input
          placeholder="搜索你感兴趣的资讯及书展"
          class="searchbar"
          id="searchword"
          @keydown.enter="search"
          clearable
        />
        <img
          src="../../assets/images/icon-search.png"
          class="search-icon"
          @click="search"
        />
      </div>
    </div>
    <div class="header">
      <div class="flex_a w12">
        <div class="aList flex">
          <div v-for="(item, idx) in menu" :key="item.id" @click="changeIndex(idx)">
            <router-link :to="routerLink(item)" :class="{ checked: index === idx }">
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loginMenu from '../inforandbook/LoginMenu.vue'
import urlSet from '@/utils/url'

export default {
  name: 'top',
  components: {
    loginMenu,
  },
  data() {
    return {
      index: 0,
      menu: null,
      customercode: '',
      showLogin: false,
      loginTab: 0,
    }
  },
  computed: {
    isLogin() {
      const token = localStorage.getItem('token')
      if (token) return true
      else return false
    },
  },
  created() {
    this.customercode = localStorage.getItem('customerCode')
  },
  mounted() {
    document.title = '知源机构服务平台 - 资讯中心'
    this.getMenu()
  },
  methods: {
    doLogin() {
      this.loginTab = 0
      this.showLogin = true
    },
    doSignUp() {
      this.loginTab = 1
      this.showLogin = true
    },
    closeDialog() {
      this.showLogin = false
    },
    // 确认是否退出
    confirmLogout() {
      this.$confirm('确定要退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'message-box',
      })
        .then(() => {
          this.doLogout()
        })
        .catch(() => {
          return false
        })
    },
    doLogout() {
      this.$http.get('/api/v1/user/accountlogout').then(res => {
        if (res.cxajaxrc == 0) {
          this.$message.success('您已成功退出')
          localStorage.clear()
          location.reload()
        }
      })
    },
    toCenter() {
      window.open('/my/#/')
    },
    routerLink(item) {
      // item.name == '书展资讯'?`/firelist?searchtype=${item.id}` :  item.path||`/ibresultlist?searchtype=${item.id}`
      // if (item.name === '书展资讯') {
      //   return `/ibresultlist?searchtype=0`
      // } else {
      //   return item.path || `/ibresultlist?searchtype=${item.id}`
      // }
      return item.path || `/ibresultlist?searchtype=${item.id}`
    },
    changeIndex(idx) {
      this.index = idx
    },
    getMenu() {
      this.$http.get('/api/v1/data/libinfotype/getAddList').then(res => {
        this.getList(res.returnvalue.libInfoTypeBeans)
      })
    },
    getList(list) {
      this.$http.get('/api/v1/data/libinfotype/getFixedList').then(res => {
        let menu = list.concat(res.returnvalue)
        menu.unshift({ id: 0, name: '首页', path: '/ibhome' })
        this.menu = menu

        let path = this.$route.path
        let query = this.$route.query
        if (path != '/ibhome') {
          let type = query.searchtype
          let idx = menu.findIndex(item => item.id == type)
          this.index = idx
        }
      })
    },
    toManagerHome() {
      location.href = '/index/#/managerhome'
    },
    toIndex() {
      // window.open("/platformhomepage.html#/sphome/homepage");
      if (this.$route.name == 'ibhome') {
        this.$router.go(0)
      }
      window.location.href = '/ic/#/ibhome'
    },
    toResources() {
      window.location.href = '/dc/#/home'
    },
    toSphome() {
      window.open(urlSet.baseUrl + '/xs/#/sphome')
    },
    toPay() {
      window.location.href = '/index/#/pay'
    },
    getLibraryConfigByShortName(shortname) {
      this.$http({
        url: `/api/v1/login/getCustomerLoginCofig?shortName=${shortname}`,
        method: 'GET',
      }).then(res => {
        if (res.cxajaxrc == 0) {
          let customerConfig = res.returnvalue
          localStorage.setItem('CustomerLoginCofig', JSON.stringify(customerConfig))
        }
      })
    },
    toknowledge() {
      window.location.href = '/kc/#/home'
    },
    search() {
      this.bus.$emit('ic-search')
      var sword = document.getElementById('searchword').value
      this.$router.push({
        path: '/searchlist',
        query: { searchword: sword },
      })
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  .search-icon {
    width: 20px;
    height: 16px !important;
    position: relative;
    top: 2px;
    left: -40px;
    cursor: pointer;
  }
  .search_main {
    margin-left: auto;
  }
  .searchbar {
    width: 350px;
    height: 36px;
    opacity: 1;
    background: #ffffff;
    border: 1px solid #08b4cf;
    border-radius: 19px;
    padding-left: 30px;
    outline: none;
    padding-right: 45px;
  }
  .top {
    height: 45px;
    background-color: #08b4cf;
    .wapper {
      line-height: 45px;
      color: #fff;
      ul {
        display: flex;
        align-items: center;
        li {
          width: 105px;
          text-align: center;
          font-size: 16px;
          cursor: pointer;
        }
        .checked {
          background: #fff;
          color: #08b4cf;
        }
      }
      > p {
        cursor: pointer;
        margin-left: 20px;
      }
      > div {
        margin-left: auto;
      }
    }
  }
  .logosearch {
    width: 1200px;
    margin-top: 20px;
    margin-bottom: 10px;
    img {
      height: 50px;
    }
  }
  .header {
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 20px;
    .w12 {
      width: 1200px;
      margin: 0px auto;
      height: 54px;
    }
    > div {
      margin: 10px 0;
      .aList {
        display: flex;
        justify-content: space-between;
        max-width: 1200px;
        > div {
          white-space: nowrap;
          overflow: hidden;
        }
        a {
          height: 36px;
          line-height: 36px;
          font-size: 18px;
          margin: 0px 17px;
          cursor: pointer;
          position: relative;
          color: #333;
          &::after {
            width: 0;
            content: '';
            position: absolute;
            bottom: -10px;
            left: 0px;
            height: 2px;
            background: #08b4cf;
            transition: all 0.2s;
          }
          &:hover {
            color: #08b4cf;
          }
        }
        .checked {
          color: #08b4cf;
          &::after {
            width: 100%;
          }
        }
      }
    }
  }
  .banner {
    height: 270px;
    background: url('../../assets/images/banner.png') no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    .search {
      position: absolute;
      width: 650px;
      height: 55px;
      background: url('../../assets/images/search-bg.png') no-repeat;
      background-size: cover;
      left: 50%;
      transform: translateX(-50%);
      bottom: 50px;
      padding: 0 20px;
      .select {
        color: #fff;
        font-size: 16px;
        border-right: 1px solid #08b4cf;
        padding-right: 10px;
        span {
          width: 50px;
        }
      }
      .searchInput {
        flex: 1;
        /deep/ .el-input__inner {
          background: none;
          border: none;
          font-size: 16px;
          color: #fff;
          &::placeholder {
            color: #fff;
          }
          &::-webkit-placeholder {
            color: #fff !important;
          }
          &::-moz-placeholder {
            color: #fff !important;
          }
          &::-ms-input-placeholder {
            color: #fff !important;
          }
        }
      }
      img {
        margin-left: auto;
        cursor: pointer;
      }
    }
  }
  .banner2 {
    height: 160px;
    background: url('../../assets/images/banner2.png') no-repeat;
    background-size: cover;
    position: relative;
  }
}
/deep/ .el-button--primary {
  background-color: #08b4cf !important;
  border-color: #08b4cf !important;
}
/deep/ .el-tabs__item.is-active {
  color: #08b4cf !important;
}
/deep/ .el-tabs__active-bar {
  background-color: #08b4cf !important;
}
/deep/ .el-tabs__item:hover {
  color: #08b4cf !important;
  cursor: pointer;
}
// /deep/ a:hover{
//   color:#08b4cf !important;
// }
/deep/ .el-checkbox__inner:hover {
  color: #08b4cf !important;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #08b4cf !important;
  border-color: #08b4cf !important;
}
/deep/ .el-checkbox__inner {
  border-color: #08b4cf !important;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #08b4cf !important;
}
/deep/ .el-input__inner:focus {
  border-color: #08b4cf !important;
}
/deep/ .el-checkbox__inner:hover {
  border-color: #08b4cf;
}
/deep/ .el-checkbox__input.is-focus {
  border-color: #08b4cf;
}
/deep/ .el-button--primary:focus,
/deep/ .el-button--primary:hover {
  background: #43aad3 !important;
}
.login-wrapper {
  .login {
    line-height: 45px;
    span {
      cursor: pointer;
    }
    .line {
      margin: 0 5px;
      padding: 0 5px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/inforandbook/top.vue